import React, { Children } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import OutboundLink from '../../../../../../atoms/OutboundLink';
import { EVENT_CATEGORIES, EVENT_ACTIONS } from '../../../../../analytics/components/Event';
import { ChildrenPropType } from '../../../../types/component';
import './Platform.css';
var propTypes = {
  children: ChildrenPropType.isRequired,
  url: PropTypes.string,
  platform: PropTypes.string
};
var defaultProps = {
  url: '',
  platform: ''
};
export default function Platform(_ref) {
  var children = _ref.children,
    url = _ref.url,
    platform = _ref.platform;
  var raw = Children.toArray(children) || [];
  if (_isEmpty(raw)) {
    return null;
  }
  var linked = /*#__PURE__*/React.createElement(OutboundLink, {
    to: url,
    label: platform,
    "aria-label": platform,
    event: {
      category: EVENT_CATEGORIES.SOCIAL_EVENT_CATEGORY,
      action: EVENT_ACTIONS.SOCIAL_MEDIA_VIEW_EVENT_ACTION,
      label: platform
    }
  }, raw);
  var content = !_isEmpty(url) ? linked : /*#__PURE__*/React.createElement(React.Fragment, null, raw);
  return content;
}
Platform.propTypes = propTypes;
Platform.defaultProps = defaultProps;